import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { Avatar } from 'antd';
import { UserOutlined, MenuOutlined, DashboardOutlined, LogoutOutlined } from '@ant-design/icons';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Select, MenuItem, FormControl, InputLabel, Menu, IconButton, Divider, Typography, Box, Dialog, DialogTitle, DialogContent, DialogActions, TextField, InputAdornment, Button } from '@mui/material';
import { Home, Person, ExitToApp, Facebook, Twitter, Instagram, ExpandMore, Build, House, Visibility, VisibilityOff } from '@mui/icons-material';
import newMsgSound from '../../utils/message-sound';
import { isAuthenticated } from '../../../services/auth';
import {
  viewUser,
  getUser,
  getUserNotifications,
  setMsgToUnread,
  updatePassword,
} from '../../../services/user';
import { allCategories } from '../../../services/category';
import { useDispatch, useSelector } from 'react-redux';
import socket from '../../../utils/socket'; // Use o socket único

const NavMenu = () => {
  const userInfo = useSelector((state) => state.buynsellUser);
  const dispatch = useDispatch();

  const [notifications, setNotifications] = useState([]);
  const [notificationCount, setNotificationCount] = useState(null);
  const [sellHover, setSellHover] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [unreadMessages, setUnreadMessages] = useState(0);
  const [passwordModalOpen, setPasswordModalOpen] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    newPassword: '',
    confirmPassword: '',
  });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [loadingPassword, setLoadingPassword] = useState(false);
  const selectedType = useSelector((state) => state.typeFilter);
  const { user, token } = isAuthenticated();
  const history = useHistory();
  const location = useLocation();

  const [isMobile, setIsMobile] = useState(window.innerWidth < 992);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 992);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const loadUser = async () => {
    if (user) {
      let res = await viewUser(user._id);
      let userNotifications = await getUserNotifications(user._id);
      dispatch({
        type: 'USER_DETAILS',
        payload: res.data,
      });
      setNotifications(userNotifications.data.notifications);
      setNotificationCount(userNotifications.data.currentNotificationCount);
    }
  };

  const loadCategories = async () => {
    try {
      const res = await allCategories();
      setCategories(res.data);
    } catch (error) {
      console.error('Error loading categories:', error);
    }
  };

  useEffect(() => {
    loadUser();
    loadCategories();
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      if (!socket.connected) {
        socket.connect();
        socket.emit('join', { userId: user._id });
      }

      socket.on('newMsgReceived', ({ newMsg }) => {
        if (window.location.pathname !== '/messages') {
          setUnreadMessages((prev) => prev + 1);
          newMsgSound(newMsg.senderName);
        }
      });

      socket.on('messagesRead', () => {
        setUnreadMessages(0);
      });
    }

    return () => {
      socket.off('newMsgReceived');
      socket.off('messagesRead');
    };
  }, [user]);

  useEffect(() => {
    if (location.pathname === '/messages') {
      setUnreadMessages(0);
      if (user) {
        socket.emit('messagesRead', { userId: user._id });
      }
    }
  }, [location, user]);

  const logout = () => {
    window.localStorage.removeItem('buynsell');
    history.push('/login');
    window.location.reload();
  };

  const handleSell = () => {
    if (isAuthenticated()) {
      history.push(`/add-product/${user._id}`);
    } else {
      history.push('/login');
    }
  };

  const handlePasswordChange = (field) => (event) => {
    setPasswordForm({ ...passwordForm, [field]: event.target.value });
  };

  const handlePasswordSubmit = async () => {
    if (passwordForm.newPassword !== passwordForm.confirmPassword) {
      alert('As senhas não coincidem');
      return;
    }
    setLoadingPassword(true);
    try {
      await updatePassword(user._id, {
        password: passwordForm.newPassword,
        newPasswordConfirm: passwordForm.confirmPassword,
      }, token);
      alert('Senha alterada com sucesso');
      setPasswordModalOpen(false);
      setPasswordForm({ newPassword: '', confirmPassword: '' });
    } catch (err) {
      alert('Erro ao alterar senha: ' + (err.response?.data?.error || err.message));
    } finally {
      setLoadingPassword(false);
    }
  };

  // Itens do menu para mobile e desktop
  const navLinks = (isMobile) => {
    return (
      <>
       
      </>
    )
  };

  const userSection = user ? (
    <div>
      <IconButton
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 0.5, 
          padding: '4px 6px', 
          borderRadius: 2,
          height: 'auto',
          transition: 'background-color 0.2s',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.05)',
          },
        }}
      >
        <Avatar
          className="avatar"
          icon={<UserOutlined />}
          src={
            user && user.photo
              ? `${process.env.REACT_APP_API.replace(/\/api$/, '')}${user.photo}`
              : '/default-profile.png'
          }
          sx={{ width: 20, height: 20 }}
        />
        <span className="user-name">
          {userInfo && userInfo.name
            ? userInfo.name.split(' ')[0]
            : 'Usuário'}
        </span>
        <ExpandMore sx={{ fontSize: 14 }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        sx={{
          '& .MuiPaper-root': {
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
            border: '1px solid #e5e7eb',
            minWidth: 160,
          },
        }}
      >
        <MenuItem 
          onClick={() => { setAnchorEl(null); history.push('/user/dashboard'); }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            padding: '12px 16px',
            '&:hover': {
              backgroundColor: '#f3f4f6',
            },
          }}
        >
          <DashboardOutlined />
          Painel
        </MenuItem>
        <MenuItem 
          onClick={() => { setAnchorEl(null); setPasswordModalOpen(true); }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            padding: '12px 16px',
            '&:hover': {
              backgroundColor: '#f3f4f6',
            },
          }}
        >
          <i className="fas fa-key" style={{ fontSize: '16px' }}></i>
          Trocar Senha
        </MenuItem>
        <MenuItem 
          onClick={() => { setAnchorEl(null); logout(); }}
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: 1,
            padding: '12px 16px',
            '&:hover': {
              backgroundColor: '#f3f4f6',
            },
          }}
        >
          <LogoutOutlined />
          Sair
        </MenuItem>
      </Menu>
    </div>
  ) : (
    <>
      <Link
        to="/login"
        className="login-link"
      >
        Entrar
      </Link>
      {process.env.REACT_APP_ENABLE_USER_REGISTRATION === 'true' && (
        <Link
          to="/register"
          className="register-link"
        >
          Cadastrar-se
        </Link>
      )}
    </>
  );

  return (
    <nav className="custom-navbar">
      <div className="container">
        {/* Logo à esquerda */}
        <Link
          className="navbar-brand d-flex align-items-center"
          to="/"
        >
          {process.env.REACT_APP_LOGO_PATH ? (
            <img
              className="logo-img"
              src={process.env.REACT_APP_LOGO_PATH}
              alt="Logo"
              style={{ height: process.env.REACT_APP_LOGO_HEIGHT ? `${process.env.REACT_APP_LOGO_HEIGHT}px` : '50px' }}
            />
          ) : (
            <svg
              className="logo-svg"
              height={process.env.REACT_APP_LOGO_HEIGHT ? `${process.env.REACT_APP_LOGO_HEIGHT}px` : '50px'}
              viewBox="0 0 200 200"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="200" height="200" fill="#4CAF50" rx="10" />
              <text x="100" y="120" fontSize="60" fontWeight="bold" textAnchor="middle" fill="white" fontFamily="Poppins">
                LD
              </text>
            </svg>
          )}
        </Link>

        {/* Desktop menu */}
        {!isMobile && (
          <>
            <div className="d-flex align-items-center" style={{ gap: '40px', flex: 1, justifyContent: 'center' }}>
              <button
                onClick={() => {
                  dispatch({ type: 'SET_TYPE_FILTER', payload: 'imovel' });
                  history.push('/');
                }}
                className={`type-filter-btn ${selectedType === 'imovel' ? 'active' : ''}`}
              >
                <i className="fas fa-home"></i>
                <span>Imóveis</span>
              </button>
              <button
                onClick={() => {
                  dispatch({ type: 'SET_TYPE_FILTER', payload: 'servico' });
                  history.push('/');
                }}
                className={`type-filter-btn ${selectedType === 'servico' ? 'active' : ''}`}
              >
                <i className="fas fa-tools"></i>
                <span>Serviços</span>
              </button>
            </div>
            <div className="d-flex align-items-center social-icons">
              {navLinks()}
              <div style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                <a href={process.env.REACT_APP_FACEBOOK_URL || "#"} className="icon" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook-f"></i>
                </a>
                <a href={process.env.REACT_APP_TWITTER_URL || "#"} className="icon" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-twitter"></i>
                </a>
                <a href={process.env.REACT_APP_INSTAGRAM_URL || "#"} className="icon" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
              </div>
              {userSection}
            </div>
          </>
        )}

        {/* Mobile menu button */}
        {isMobile && (
          <>
            <button
              className="mobile-menu-btn"
              onClick={() => setDrawerVisible(!drawerVisible)}
              aria-label="Abrir menu"
            >
              <MenuOutlined />
            </button>

            <Drawer
              anchor="right"
              open={drawerVisible}
              onClose={() => setDrawerVisible(false)}
              PaperProps={{
                sx: {
                  width: 280,
                  backgroundColor: '#fafafa',
                }
              }}
            >
              <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                {/* Header com User Info */}
                <Box sx={{ 
                  padding: 2, 
                  textAlign: 'center', 
                  backgroundColor: '#fafafa',
                  color: 'black',
                  borderRadius: '0 0 16px 16px'
                }}>
                  <img
                    src={
                      user && user.photo
                        ? `${process.env.REACT_APP_API.replace(/\/api$/, '')}${user.photo}`
                        : '/default-profile.png'
                    }
                    alt="Profile"
                    style={{
                      width: 80,
                      height: 80,
                      borderRadius: '50%',
                      border: '3px solid white',
                      display: 'block',
                      margin: '0 auto 8px auto',
                      objectFit: 'cover'
                    }}
                  />
                  <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                    {userInfo && userInfo.name
                      ? userInfo.name.split(' ')[0]
                      : 'Bem-vindo'}
                  </Typography>
                  {user && (
                    <Typography variant="body2" sx={{ opacity: 0.9 }}>
                      {userInfo && userInfo.email}
                    </Typography>
                  )}
                </Box>

                {/* Menu Items */}
                <List sx={{ flex: 1, pt: 1 }}>
                  {/* Navegação Principal */}
                  <ListItem button component={Link} to="/" onClick={() => setDrawerVisible(false)}
                    sx={{
                      mx: 1,
                      borderRadius: 2,
                      mb: 0.5,
                      '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                    }}>
                    <ListItemIcon sx={{ color: 'primary.main' }}>
                      <Home />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Início" 
                      primaryTypographyProps={{ fontWeight: 'medium' }}
                    />
                  </ListItem>

                  <Divider sx={{ my: 1, mx: 2 }} />

                  {/* Tipos de Anúncio */}
                  <Typography variant="subtitle2" sx={{ px: 3, py: 1, color: 'text.secondary', fontWeight: 'bold' }}>
                    EXPLORAR
                  </Typography>
                  
                  <ListItem
                    button
                    onClick={() => { 
                      dispatch({ type: 'SET_TYPE_FILTER', payload: 'imovel' }); 
                      setDrawerVisible(false); 
                      history.push('/'); 
                    }}
                    sx={{
                      mx: 1,
                      borderRadius: 2,
                      mb: 0.5,
                      backgroundColor: selectedType === 'imovel' ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                      '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                    }}
                  >
                    <ListItemIcon sx={{ color: selectedType === 'imovel' ? 'primary.main' : 'inherit' }}>
                      <House />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Imóveis" 
                      primaryTypographyProps={{ 
                        fontWeight: selectedType === 'imovel' ? 'bold' : 'medium',
                        color: selectedType === 'imovel' ? 'primary.main' : 'inherit'
                      }}
                    />
                  </ListItem>
                  
                  <ListItem
                    button
                    onClick={() => { 
                      dispatch({ type: 'SET_TYPE_FILTER', payload: 'servico' }); 
                      setDrawerVisible(false); 
                      history.push('/'); 
                    }}
                    sx={{
                      mx: 1,
                      borderRadius: 2,
                      mb: 0.5,
                      backgroundColor: selectedType === 'servico' ? 'rgba(25, 118, 210, 0.08)' : 'transparent',
                      '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                    }}
                  >
                    <ListItemIcon sx={{ color: selectedType === 'servico' ? 'primary.main' : 'inherit' }}>
                      <Build />
                    </ListItemIcon>
                    <ListItemText 
                      primary="Serviços" 
                      primaryTypographyProps={{ 
                        fontWeight: selectedType === 'servico' ? 'bold' : 'medium',
                        color: selectedType === 'servico' ? 'primary.main' : 'inherit'
                      }}
                    />
                  </ListItem>

                  <Divider sx={{ my: 1, mx: 2 }} />

                  {/* Conta do Usuário */}
                  <Typography variant="subtitle2" sx={{ px: 3, py: 1, color: 'text.secondary', fontWeight: 'bold' }}>
                    CONTA
                  </Typography>

                  {user ? (
                    <>
                      <ListItem button component={Link} to="/user/dashboard" onClick={() => setDrawerVisible(false)}
                        sx={{
                          mx: 1,
                          borderRadius: 2,
                          mb: 0.5,
                          '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                        }}>
                        <ListItemIcon>
                          <Person />
                        </ListItemIcon>
                        <ListItemText 
                          primary="Meu Painel" 
                          primaryTypographyProps={{ fontWeight: 'medium' }}
                        />
                      </ListItem>
                      <ListItem button onClick={() => { setDrawerVisible(false); setPasswordModalOpen(true); }}
                        sx={{
                          mx: 1,
                          borderRadius: 2,
                          mb: 0.5,
                          '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                        }}>
                        <ListItemIcon>
                          <i className="fas fa-key" style={{ fontSize: '20px' }}></i>
                        </ListItemIcon>
                        <ListItemText 
                          primary="Trocar Senha" 
                          primaryTypographyProps={{ fontWeight: 'medium' }}
                        />
                      </ListItem>
                      <ListItem button onClick={() => { setDrawerVisible(false); logout(); }}
                        sx={{
                          mx: 1,
                          borderRadius: 2,
                          mb: 0.5,
                          '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                        }}>
                        <ListItemIcon sx={{ color: 'error.main' }}>
                          <ExitToApp />
                        </ListItemIcon>
                        <ListItemText 
                          primary="Sair" 
                          primaryTypographyProps={{ fontWeight: 'medium', color: 'error.main' }}
                        />
                      </ListItem>
                    </>
                  ) : (
                    <>
                      <ListItem button component={Link} to="/login" onClick={() => setDrawerVisible(false)}
                        sx={{
                          mx: 1,
                          borderRadius: 2,
                          mb: 0.5,
                          '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                        }}>
                        <ListItemIcon>
                          <Person />
                        </ListItemIcon>
                        <ListItemText 
                          primary="Entrar" 
                          primaryTypographyProps={{ fontWeight: 'medium' }}
                        />
                      </ListItem>
                      {process.env.REACT_APP_ENABLE_USER_REGISTRATION === 'true' && (
                        <ListItem button component={Link} to="/register" onClick={() => setDrawerVisible(false)}
                          sx={{
                            mx: 1,
                            borderRadius: 2,
                            mb: 0.5,
                            '&:hover': { backgroundColor: 'rgba(0,0,0,0.04)' }
                          }}>
                          <ListItemIcon>
                            <Person />
                          </ListItemIcon>
                          <ListItemText 
                            primary="Cadastrar-se" 
                            primaryTypographyProps={{ fontWeight: 'medium' }}
                          />
                        </ListItem>
                      )}
                    </>
                  )}
                </List>

                {/* Social Icons no Footer */}
                <Box sx={{ 
                  p: 2, 
                  borderTop: '1px solid #e0e0e0',
                  backgroundColor: 'white'
                }}>
                  <Typography variant="subtitle2" sx={{ mb: 1, color: 'text.secondary', textAlign: 'center' }}>
                    Siga-nos
                  </Typography>
                  <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
                    <IconButton 
                      href={process.env.REACT_APP_FACEBOOK_URL || "#"} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      sx={{ color: '#1877f2' }}
                    >
                      <Facebook />
                    </IconButton>
                    <IconButton 
                      href={process.env.REACT_APP_TWITTER_URL || "#"} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      sx={{ color: '#1da1f2' }}
                    >
                      <Twitter />
                    </IconButton>
                    <IconButton 
                      href={process.env.REACT_APP_INSTAGRAM_URL || "#"} 
                      target="_blank" 
                      rel="noopener noreferrer"
                      sx={{ color: '#e4405f' }}
                    >
                      <Instagram />
                    </IconButton>
                  </Box>
                </Box>
              </Box>
            </Drawer>
          </>
        )}
      </div>

      {/* Password Change Modal */}
      <Dialog
        open={passwordModalOpen}
        onClose={() => setPasswordModalOpen(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Trocar Senha</DialogTitle>
        <DialogContent>
          <TextField
            label="Nova Senha"
            type={showNewPassword ? 'text' : 'password'}
            fullWidth
            margin="normal"
            value={passwordForm.newPassword}
            onChange={handlePasswordChange('newPassword')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowNewPassword(!showNewPassword)}
                    edge="end"
                  >
                    {showNewPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
          <TextField
            label="Confirmar Nova Senha"
            type={showConfirmPassword ? 'text' : 'password'}
            fullWidth
            margin="normal"
            value={passwordForm.confirmPassword}
            onChange={handlePasswordChange('confirmPassword')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                    edge="end"
                  >
                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setPasswordModalOpen(false)} disabled={loadingPassword}>
            Cancelar
          </Button>
          <Button onClick={handlePasswordSubmit} variant="contained" disabled={loadingPassword}>
            {loadingPassword ? 'Alterando...' : 'Alterar Senha'}
          </Button>
        </DialogActions>
      </Dialog>
    </nav>
  );
};

export default NavMenu;
